import React, {useEffect, useState} from "react";
import {FlexColumnCentered} from "../../../../components/ui/Content";
import {ButtonDefault, ButtonPrimary} from "../../../../components/ui/Button";
import {FormTitle} from "../../../../components/Font";
import {useTranslation} from "react-i18next";
import {InputElement} from "../../../../ui/Input/Input";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {
    ButtonContainer,
    RecoveryInputContainer,
    RegisterInputContainer
} from "../../../../components/ui/InputSearch";
import {useTheme} from "styled-components";
import {cleanErrorEnter, InitiateChangeData, setChangeDataForChangeNull, setChangeSuccessFalse} from "../UserInfo/slice";
import {LoaderContainer, LoaderEnum, MiniLoader} from "../../../../ui/Loader/MiniLoader";
import { setChangeDataModal, setChangeDataModalDataForChange} from "../api/slice";
import {DataForChange} from "../../../../enum/personalInfo";
import {ChangeDataModalInit} from "../../../../interface/Passport/Account/frontend";


export const EnterEmailForm = () => {

    const {t} = useTranslation();
    const dispatch = useAppDispatch()
    const Theme = useTheme()
    const [email, setEmail] = useState('')
    const {isFetching,error,setChangeDataForChange} = useAppSelector(state => state.user)

    const validate=()=>{
        const pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        if(pattern.test(email)){
            return false
        } else{
            return true
        }
    }
    const closeModal = () => {
        dispatch(setChangeDataModal(ChangeDataModalInit))
        dispatch(setChangeSuccessFalse())
        dispatch(setChangeDataForChangeNull())
    }

    useEffect(() => {
        dispatch(setChangeDataModalDataForChange(setChangeDataForChange))
    }, [setChangeDataForChange])
    
    return <>
        <FlexColumnCentered style={{width: '100%', marginTop: '10px'}}>
            <FormTitle>Введите новый e-mail</FormTitle>
        </FlexColumnCentered>
        <RegisterInputContainer>
            <RecoveryInputContainer style={{marginTop: '28px', }}>
                <InputElement
                    autofocus={true}
                    value={email}
                    onChange={value => {
                        if (error['data']) {
                            dispatch(cleanErrorEnter('data'))
                        }
                        setEmail(value)
                    }}
                    placeholder='E-mail'
                    error={error['data']}
                    onKeyDown={(key) => {
                        if (key === 'Enter' && email.length >= 5) {
                            dispatch(InitiateChangeData(
                                {
                                    data: email,
                                    type_id: DataForChange.email
                                }
                            ))
                        }
                    }}
                />
            </RecoveryInputContainer>
        </RegisterInputContainer>
        <ButtonContainer style={{marginTop: '34px'}}>
            <ButtonDefault style={{width: '165px'}} onClick={closeModal}>Отмена</ButtonDefault>
            {isFetching
                ? <ButtonPrimary style={{
                    width: '165px',
                    marginLeft: '20px'

                }} disabled={isFetching}>
                    <LoaderContainer>
                        <MiniLoader color={Theme.color.primaryBackground} size={LoaderEnum.small}/>
                    </LoaderContainer>
                </ButtonPrimary>
                : <ButtonPrimary
                    disabled={validate()}
                    onClick={() => {
                        dispatch(InitiateChangeData(
                            {
                                data: email,
                                type_id: DataForChange.email
                            }
                        ))
                    }}
                    style={{
                        width: '165px',
                        marginLeft: '20px'
                    }}>
                    {t('auth.continue')}
                </ButtonPrimary>}
        </ButtonContainer>
    </>
}


